import { useSplitClient } from '@splitsoftware/splitio-react';

const useIsConciergeEnabled = (options) => {
    var _a;
    const splitIO = useSplitClient();
    const conciergeTreatment = (_a = splitIO.client) === null || _a === void 0 ? void 0 : _a.getTreatment('brandclub_concierge', {
        email: (options === null || options === void 0 ? void 0 : options.email) || '',
    });
    const showWidget = true; // Brandclub only, brandclub-checkout-shop-app/.../ConciergeButton.tsx controls for DTC
    const showConversationStarters = true; // Brandclub only, show for everyone
    const showInHeader = conciergeTreatment !== 'off'; // only show if split treatment is not off
    return {
        showWidget,
        showConversationStarters,
        showInHeader,
    };
};

export { useIsConciergeEnabled };
//# sourceMappingURL=useIsConciergeEnabled.js.map
